// src/components/pages/watch/VideoPlayerPage.js
import React, { useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const VideoPlayerPage = () => {
  const { episodeId } = useParams();
  const navigate = useNavigate();
  const videoRef = useRef(null);

  // Placeholder video meta data.
  const [videoMeta] = useState({
    title: `Episode ${episodeId}: Placeholder Title`,
    description:
      "This is a placeholder description for the selected video. Enjoy the show!",
    source: "https://www.w3schools.com/html/mov_bbb.mp4",
  });

  // Fullscreen container styles.
  const containerStyle = {
    position: "relative",
    width: "100vw",
    height: "100vh",
    backgroundColor: "#000",
    overflow: "hidden",
  };

  // Video is styled to fill the container while preserving aspect ratio (letterboxing if needed).
  const videoStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  };

  // Overlay meta data styling.
  const overlayStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    bgcolor: "rgba(0,0,0,0.5)",
    color: "#fff",
    p: 2,
  };

  return (
    <Box sx={containerStyle}>
      {/* Back Button */}
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 2,
          color: "#fff",
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      {/* Video Player */}
      <video
        ref={videoRef}
        src={videoMeta.source}
        controls
        autoPlay
        style={videoStyle}
      />

      {/* Meta Data Overlay */}
      <Box sx={overlayStyle}>
        <Typography variant="h6">{videoMeta.title}</Typography>
        <Typography variant="body2">{videoMeta.description}</Typography>
      </Box>
    </Box>
  );
};

export default VideoPlayerPage;
